/* eslint-disable @typescript-eslint/no-explicit-any */
import { useForm } from 'react-hook-form';
import Container from '../Container';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import SubContainer from '../Container/SubContainer';
// import { Select, SelectContent, SelectItem, SelectLabel, SelectTrigger, SelectValue } from '@/components/ui/select';
// import { SelectGroup } from '@radix-ui/react-select';
import Button from '../Button';
import Divider from '../Divider';
import {
  ComponentCommonSearchSection,
  // ComponentCommonTypes,
  Maybe,
} from '@/graphql/generated/graphql';
import { ReactNode } from 'react';
import Pagination from '../Pagination';
// import useTranslation from '@/hooks/i18n';
import { classNames } from '@/utils/class-names';

const schema = z.object({
  search: z.string().default('').optional(),
  kinds: z.array(z.string()).default([]).optional(),
  topic: z.string().default('').optional(),
  theme: z.string().default('').optional(),
});

export interface Pagination {
  page: number;
  pageCount: number;
  total: number;
}

export interface SearchTabProps {
  children: ReactNode;
  searchSection?: Maybe<ComponentCommonSearchSection>;
  data: any[];
  pageable?: Pagination;
  onChangePage: (page: number) => void;
  onChangeFilters: (filters: any) => void;
}

export default function SearchTab({
  children,
  searchSection,
  data,
  pageable,
  onChangePage,
  onChangeFilters,
}: SearchTabProps) {
  const {
    register,
    // setValue,
    handleSubmit,
    // getValues
  } = useForm({
    resolver: zodResolver(schema),
  });
  //   const { t } = useTranslation();

  //   const shouldRenderTopicsAndThemes =
  //     (searchSection?.topics?.data?.length || 0) > 0 || (searchSection?.themes?.data?.length || 0) > 0;

  //   const handleCheckboxChange = (option: Maybe<ComponentCommonTypes>) => {
  //     const currentKind = getValues('kinds') || [];
  //     if (currentKind.includes(option?.type || '')) {
  //       setValue(
  //         'kinds',
  //         currentKind.filter((type: string) => type !== option?.type),
  //       );
  //     } else {
  //       setValue('kinds', [...currentKind, option?.type]);
  //     }
  //   };

  //   const renderOptions = (option: Maybe<ComponentCommonTypes>) => {
  //     return (
  //       <div className="relative mt-sh-15 flex items-start">
  //         <div className="flex h-6 items-center">
  //           <input type="checkbox" onChange={() => handleCheckboxChange(option)} />
  //         </div>
  //         <div className="ml-3 text-sm leading-6">
  //           <label htmlFor="candidates" className=" text-sh-xs">
  //             {t(option?.type || '')}
  //           </label>
  //         </div>
  //       </div>
  //     );
  //   };

  //   const renderSelect = ({
  //     title,
  //     placeholder,
  //     attr,
  //     values,
  //   }: {
  //     title: string;
  //     placeholder: string;
  //     attr: 'topic' | 'theme';
  //     values: any[];
  //   }) => {
  //     if (!values || !values.length) return null;
  //     return (
  //       <div className=" w-full">
  //         <Select
  //           onValueChange={(value) => {
  //             setValue(attr, value);
  //           }}>
  //           <SelectGroup>
  //             <SelectLabel className=" mb-sh-15 px-0 text-sh-xs font-normal">{title}</SelectLabel>
  //           </SelectGroup>
  //           <SelectTrigger>
  //             <SelectValue placeholder={placeholder} />
  //           </SelectTrigger>
  //           <SelectContent>
  //             <SelectGroup>
  //               <SelectItem key={placeholder} value={'null'}>
  //                 {placeholder}
  //               </SelectItem>
  //               {values.map((value) => (
  //                 <SelectItem key={value} value={value}>
  //                   {t(value)}
  //                 </SelectItem>
  //               ))}
  //             </SelectGroup>
  //           </SelectContent>
  //         </Select>
  //       </div>
  //     );
  //   };

  const onSubmit = async (data: any) => {
    onChangeFilters(data);
  };

  return (
    <Container className=" mt-sh-30">
      <SubContainer className=" lg:col-start-11 lg:col-end-3 ">
        <h2 className=" mb-sh-30 text-sh-md font-bold">{searchSection?.title}</h2>

        <form onSubmit={handleSubmit(onSubmit)}>
          <Label>
            <p className="mb-2 text-sh-xs">{searchSection?.searchInput}</p>
          </Label>
          <Input type="text" {...register('search')} />

          {/* {!!searchSection?.types?.length && (
            <>
              <p className="mt-6 text-sh-xs">{searchSection?.whatKindTitle}</p>
              <div className="flex flex-wrap gap-sh-15">
                {searchSection?.types?.map((option) => renderOptions(option))}
              </div>
            </>
          )}

          {shouldRenderTopicsAndThemes && (
            <div className="mt-sh-30 flex flex-col gap-4 lg:flex-row lg:gap-28">
              {renderSelect({
                title: searchSection?.chooseATopicTitle || '',
                placeholder: 'Any topic',
                attr: 'topic',
                values: searchSection?.topics?.data.map((topic) => topic.attributes?.topic) || [],
              })}
              {renderSelect({
                title: searchSection?.chooseCollectionTitle || '',
                placeholder: 'Any collection',
                attr: 'theme',
                values: searchSection?.themes?.data.map((theme) => theme.attributes?.theme) || [],
              })}
            </div>
          )} */}

          <Button theme="solid" className={classNames('mt-sh-30')} type="submit">
            Search
          </Button>
        </form>

        <Divider />

        <h2 className="mb-sh-30 text-sh-md font-bold">Your results</h2>

        {data.length > 0 && (
          <>
            <div className="flex flex-wrap gap-4">{children}</div>
            <Pagination
              pageSize={pageable?.pageCount || 0}
              currentPage={pageable?.page || 0}
              onChangePage={(page) => onChangePage(page)}
            />
          </>
        )}

        {data.length === 0 && <p>No records found</p>}
      </SubContainer>
    </Container>
  );
}
